"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewMessageRoundOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.732 2.24a5.762 5.762 0 015.932 4.732 5.754 5.754 0 01-.732 3.984.867.867 0 00-.088.694l.53 1.79-2-.479a.867.867 0 00-.618.082 5.763 5.763 0 01-7.408-1.65 5.754 5.754 0 014.384-9.152zm4.938-.104A7.497 7.497 0 00.528 7.341a7.489 7.489 0 005.837 7.962 7.498 7.498 0 004.918-.58l3.148.753a.867.867 0 001.033-1.09l-.853-2.876a7.488 7.488 0 00-1.941-9.374z",
    clipRule: "evenodd"
  })))
});
PreviewMessageRoundOutlineIcon.displayName = 'PreviewMessageRoundOutlineIcon';
var _default = exports.default = PreviewMessageRoundOutlineIcon;